export default "{\n    \"errors\": {\n        \"copyFailed\": \"Failed to copy to clipboard\"\n    }\n}\n"